import type { Uploadable } from '@/models/uploadable';

export function convertBlobToUploadable(blob: Blob, filename = 'unknown.blob'): Uploadable {
  return {
    url: URL.createObjectURL(blob),
    name: filename,
    size: blob.size,
    type: blob.type,
    compress: true,
  };
}

export function convertFileToUploadable(file: File): Uploadable {
  return {
    url: URL.createObjectURL(file),
    name: file.name,
    size: file.size,
    type: file.type,
    compress: false,
  };
}

export function convertUrlToUploadable(url: string | URL, type = ''): Uploadable {
  if (!type && url.toString().startsWith('data:')) {
    const [mediaType] =
      url
        .toString()
        .split(',')[0]
        ?.match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/) || [];

    return {
      url: url.toString(),
      name: '',
      size: 0,
      type: mediaType || type,
      compress: false,
    };
  }

  return {
    url: url.toString(),
    name: '',
    size: 0,
    type,
    compress: false,
  };
}

export async function convertUploadableToBlob(uploadable: Uploadable): Promise<Blob> {
  return fetch(uploadable.url).then((res) => res.blob());
}

export async function convertUploadableToFile(uploadable: Uploadable): Promise<File> {
  const fileBlob = await convertUploadableToBlob(uploadable);

  return new File([fileBlob], uploadable.name, { type: uploadable.type });
}

export async function convertUploadableToDataURL(uploadable: Uploadable): Promise<string> {
  const fileBlob = await convertUploadableToBlob(uploadable);

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(fileBlob);
  });
}
